/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Trimp_RangeInputs */

const en_exp_trimp_range = /** @type {(inputs: Exp_Trimp_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalized to TSS scale: 100 for one hour at your threshold HR — estimated at 88% of your heart rate reserve when you haven't set one. Under 150: low stress, quick recovery. 150-300: moderate, some residual fatigue. 300-450: high, requires 2+ days recovery. 450+: very high, extended recovery needed.`)
};

const de_exp_trimp_range = /** @type {(inputs: Exp_Trimp_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normiert auf TSS-Skala: 100 für eine Stunde an deiner Schwellen-HF – ohne eingetragenen Wert geschätzt bei 88 % deiner Herzfrequenzreserve. Unter 150: geringe Belastung, schnelle Erholung. 150–300: moderat, etwas Restmüdigkeit. 300–450: hoch, 2+ Tage Erholung. 450+: sehr hoch, lange Erholung nötig.`)
};

/**
* | output |
* | --- |
* | "Normalized to TSS scale: 100 for one hour at your threshold HR — estimated at 88% of your heart rate reserve when you haven't set one. Under 150: low stress,..." |
*
* @param {Exp_Trimp_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_trimp_range = /** @type {((inputs?: Exp_Trimp_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Trimp_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_trimp_range(inputs)
	return de_exp_trimp_range(inputs)
});